import {
  LaunchObj,
  LaunchModuleObj,
  UserInputObj,
  PaginatedTaskObj,
  UserObj,
  PaginatedCommentsObj,
  CommentObj,
  TagObj,
  ReleaseNoteObj,
  UserInputCopyAssetsObj,
  LaunchSectionObj,
  TaskObj,
  GtmTimelineObj,
  ChannelObj,
  ChannelTimeframeObj,
  MilestoneObj,
  MessageGroupObj,
  AnnouncementObj,
  DisplayMessageGroupUserObj,
  TestimonialObj,
  SurveyObj,
  ObjectiveObj,
  KpiObj,
  OrganizationObj,
  CompanyObj,
  ScreenshotsObj,
  FeedbackPostDto,
  ProductBoardItemObj,
  ProductBoardRoadmapObj,
  PersonaDto,
  PersonaDemographicsCategoryDto,
  PersonaNoteDto,
  InsightObj,
  LaunchTypeObj,
  AssetObj,
  InsightsSavedSummaryObj,
  ProductBoardReleaseObj,
  FeedbackBoardDto,
  FeedbackCommentDto,
  Integration,
  CopysmithAiFavoriteObj,
  CrmIntegrationObj,
  ProductBoardCustomColumnDto,
  ProductBoardItemsGroupObj,
  PhaseObj,
  FeedbackCustomColumnDto,
  ChecklistObj,
  AiCopywritingSectionObj,
  CompetitiveIntelSectionObj,
  CampaignPlanningSectionObj,
  RoadmappingSectionObj,
  VoiceOfCustomerSectionObj,
  WinLossAnalysisSectionObj,
  WorkspaceConfigSectionObj,
  ProductBoardItemsViewObj,
  UserInOrganizationObj,
} from '~generated/types'

/*
 * Keep all used typenames here to reuse in queries.
 * Watch if some of typenames had changed.
 * TODO - replace all used __typenames in all places
 */

export const launchObjTypename: LaunchObj['__typename'] = 'LaunchObj'
export const organizationObjTypename: OrganizationObj['__typename'] = 'OrganizationObj'
export const launchModuleObjTypename: LaunchModuleObj['__typename'] = 'LaunchModuleObj'
export const launchSectionObjTypename: LaunchSectionObj['__typename'] = 'LaunchSectionObj'
export const userInputObjTypename: UserInputObj['__typename'] = 'UserInputObj'
export const userInputCopyAssetsObjTypename: UserInputCopyAssetsObj['__typename'] = 'UserInputCopyAssetsObj'
export const paginatedTaskObjTypename: PaginatedTaskObj['__typename'] = 'PaginatedTaskObj'
export const taskObjTypename: TaskObj['__typename'] = 'TaskObj'
export const integrationTypename: Integration['__typename'] = 'Integration'
export const assetObjTypename: AssetObj['__typename'] = 'AssetObj'
export const userObjTypename: UserObj['__typename'] = 'UserObj'
export const tagObjTypename: TagObj['__typename'] = 'TagObj'
export const messageGroupObjTypename: MessageGroupObj['__typename'] = 'MessageGroupObj'
export const announcementObjTypename: AnnouncementObj['__typename'] = 'AnnouncementObj'
export const commentObjTypename: CommentObj['__typename'] = 'CommentObj'
export const paginatedCommentsObjTypename: PaginatedCommentsObj['__typename'] = 'PaginatedCommentsObj'
export const releaseNoteObjTypename: ReleaseNoteObj['__typename'] = 'ReleaseNoteObj'
export const insightObjTypename: InsightObj['__typename'] = 'InsightObj'
export const surveyObjTypename: SurveyObj['__typename'] = 'SurveyObj'
export const testimonialObjTypename: TestimonialObj['__typename'] = 'TestimonialObj'
export const objectiveObjTypename: ObjectiveObj['__typename'] = 'ObjectiveObj'
export const kpiObjTypename: KpiObj['__typename'] = 'KpiObj'
export const gtmTimelineObjTypename: GtmTimelineObj['__typename'] = 'GtmTimelineObj'
export const channelObjTypename: ChannelObj['__typename'] = 'ChannelObj'
export const channelTimeframeObjTypename: ChannelTimeframeObj['__typename'] = 'ChannelTimeframeObj'
export const milestoneObjTypename: MilestoneObj['__typename'] = 'MilestoneObj'
export const displayMessageGroupUserObjTypename: DisplayMessageGroupUserObj['__typename'] = 'DisplayMessageGroupUserObj'
export const batteCardTypename: CompanyObj['__typename'] = 'CompanyObj'
export const battleCardScreenshotsTypename: ScreenshotsObj['__typename'] = 'ScreenshotsObj'
export const feedbackBoardTypename: FeedbackBoardDto['__typename'] = 'FeedbackBoardDto'
export const feedbackCustomColumnTypename: FeedbackCustomColumnDto['__typename'] = 'FeedbackCustomColumnDto'
export const feedbackPostTypename: FeedbackPostDto['__typename'] = 'FeedbackPostDto'
export const feedbackPostCommentTypename: FeedbackCommentDto['__typename'] = 'FeedbackCommentDto'
export const productBoardRoadmapDtoTypename: ProductBoardRoadmapObj['__typename'] = 'ProductBoardRoadmapObj'
export const productBoardItemTypename: ProductBoardItemObj['__typename'] = 'ProductBoardItemObj'
export const productBoardReleaseTypename: ProductBoardReleaseObj['__typename'] = 'ProductBoardReleaseObj'
export const productBoardCustomColumnTypename: ProductBoardCustomColumnDto['__typename'] = 'ProductBoardCustomColumnDto'
export const productBoardItemsViewTypename: ProductBoardItemsViewObj['__typename'] = 'ProductBoardItemsViewObj'
export const productBoardItemsGroupTypename: ProductBoardItemsGroupObj['__typename'] = 'ProductBoardItemsGroupObj'
export const companyObjTypename: CompanyObj['__typename'] = 'CompanyObj'
export const personaDtoTypename: PersonaDto['__typename'] = 'PersonaDto'
export const personaNoteDtoTypename: PersonaNoteDto['__typename'] = 'PersonaNoteDto'
export const personaDemographicsCategoryDtoTypename: PersonaDemographicsCategoryDto['__typename'] =
  'PersonaDemographicsCategoryDto'
export const launchTypeObjTypename: LaunchTypeObj['__typename'] = 'LaunchTypeObj'
export const InsightsSavedSummaryObjTypename: InsightsSavedSummaryObj['__typename'] = 'InsightsSavedSummaryObj'
export const copysmithAIFavoritesObjTypename: CopysmithAiFavoriteObj['__typename'] = 'CopysmithAIFavoriteObj'
export const crmIntegrationObjTypename: CrmIntegrationObj['__typename'] = 'CrmIntegrationObj'
export const PhasesTypename: PhaseObj['__typename'] = 'PhaseObj'
export const checklistObjTypename: ChecklistObj['__typename'] = 'ChecklistObj'
export const aiCopywritingSectionObjTypename: AiCopywritingSectionObj['__typename'] = 'AiCopywritingSectionObj'
export const competitiveIntelSectionObjTypename: CompetitiveIntelSectionObj['__typename'] = 'CompetitiveIntelSectionObj'
export const campaignPlanningSectionObjTypename: CampaignPlanningSectionObj['__typename'] = 'CampaignPlanningSectionObj'
export const roadmappingSectionObjTypename: RoadmappingSectionObj['__typename'] = 'RoadmappingSectionObj'
export const voiceOfCustomerSectionObjTypename: VoiceOfCustomerSectionObj['__typename'] = 'VoiceOfCustomerSectionObj'
export const winLossAnalysisSectionObjTypename: WinLossAnalysisSectionObj['__typename'] = 'WinLossAnalysisSectionObj'
export const workspaceConfigSectionObjTypename: WorkspaceConfigSectionObj['__typename'] = 'WorkspaceConfigSectionObj'
export const userInOrganizationObjTypename: UserInOrganizationObj['__typename'] = 'UserInOrganizationObj'
